// extracted by mini-css-extract-plugin
module.exports = {"offersBadge":"offers-badge_offersBadge__CYd_R"};